import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{attrs:{"id":"event"}},[_c('app-city-header',{attrs:{"payload":_vm.payload}}),_c(VRow,[_c(VCol,[_c('single-calendar')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }